(function () {
  if (window.__apInit) return;
  window.__apInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ap-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    return observer;
  }

  function initReveals(root) {
    var els = root.querySelectorAll('.ap-reveal:not([data-ap-observed]), .ap-pasos-linea:not([data-ap-observed])');
    if (reduceMotion) {
      els.forEach(function (el) {
        el.classList.add('ap-visible');
        el.setAttribute('data-ap-observed', '1');
      });
      return;
    }
    var obs = getObserver();
    els.forEach(function (el) {
      el.setAttribute('data-ap-observed', '1');
      obs.observe(el);
    });
  }

  function initMagneticButtons(root) {
    if (reduceMotion) return;
    var btns = root.querySelectorAll('[data-magnetic]:not([data-ap-init])');
    btns.forEach(function (btn) {
      btn.setAttribute('data-ap-init', '1');
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.12).toFixed(1) + 'px,' + (y * 0.12).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = 'translate(0,0)';
      });
    });
  }

  function initMagneticCards(root) {
    if (reduceMotion) return;
    var cards = root.querySelectorAll('.ap-beneficio-card:not([data-ap-init])');
    cards.forEach(function (card) {
      card.setAttribute('data-ap-init', '1');
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - rect.left) + 'px');
        card.style.setProperty('--my', (e.clientY - rect.top) + 'px');
      });
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll('.ap-faq-item:not([data-ap-init])');
    items.forEach(function (item) {
      item.setAttribute('data-ap-init', '1');
      var btn = item.querySelector('.ap-faq-pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.getAttribute('data-abierto') === 'true';
        item.closest('.ap-faq-lista').querySelectorAll('.ap-faq-item').forEach(function (i) {
          if (i !== item) i.setAttribute('data-abierto', 'false');
        });
        item.setAttribute('data-abierto', abierto ? 'false' : 'true');
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initReveals(root);
    initMagneticButtons(root);
    initMagneticCards(root);
    initFaq(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
